import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';

// Sayfalar
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Collections from './pages/Collections';
import Shipments from './pages/Shipments';
import ReadyToShip from './pages/ReadyToShip';
import AgingReport from './pages/AgingReport';
import Users from './pages/Users';
import FileSharing from './pages/FileSharing';
import CollectionReports from './pages/CollectionReports';
import ShipmentReports from './pages/ShipmentReports';
import CompanyTasks from './pages/CompanyTasks';
import MobileAnnouncements from './pages/MobileAnnouncements';
import Personnel from './pages/Personnel';
import Reconciliations from './pages/Reconciliations';
import NotificationSettings from './pages/NotificationSettings';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ErrorBoundary>
          <Router>
            <div className="min-h-screen bg-dark-bg text-dark-text font-sans selection:bg-primary-500 selection:text-white transition-colors duration-300">
              <Routes>
                {/* Herkese (Giriş Yapmamışlara) Açık Kısım */}
                <Route path="/login" element={<Login />} />

                {/* Sadece Giriş Yapmışların Görebileceği Kısımlar */}
                <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/collections" element={<PrivateRoute><Collections /></PrivateRoute>} />
                <Route path="/shipments" element={<PrivateRoute><Shipments /></PrivateRoute>} />
                <Route path="/ready-to-ship" element={<PrivateRoute><ReadyToShip /></PrivateRoute>} />
                <Route path="/aging" element={<PrivateRoute><AgingReport /></PrivateRoute>} />
                <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
                <Route path="/files" element={<PrivateRoute><FileSharing /></PrivateRoute>} />
                <Route path="/collection-reports" element={<PrivateRoute><CollectionReports /></PrivateRoute>} />
                <Route path="/shipment-reports" element={<PrivateRoute><ShipmentReports /></PrivateRoute>} />
                <Route path="/company-tasks" element={<PrivateRoute><CompanyTasks /></PrivateRoute>} />
                <Route path="/mobile-announcements" element={<PrivateRoute><MobileAnnouncements /></PrivateRoute>} />
                <Route path="/personnel" element={<PrivateRoute><Personnel /></PrivateRoute>} />
                <Route path="/reconciliations" element={<PrivateRoute><Reconciliations /></PrivateRoute>} />
                <Route path="/notifications" element={<PrivateRoute><NotificationSettings /></PrivateRoute>} />

                {/* Bilinmeyen rotaya girilirse Login sayfasına yönlendir */}
                <Route path="*" element={<Navigate to="/login" />} />
              </Routes>
            </div>
          </Router>
        </ErrorBoundary>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
